import { render, staticRenderFns } from "./modalWrapper.vue?vue&type=template&id=40ab12be"
import script from "./modalWrapper.vue?vue&type=script&lang=ts"
export * from "./modalWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports